module.exports = __webpack_public_path__ + "img/lock-open.f6f4ff1.svg";